"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceBanner = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const solid_1 = require("@heroicons/react/24/solid");
function MaintenanceBanner({ message = 'We are planning scheduled maintenance at 10PM EST. We expect it to last ~1 hour.', title = 'Scheduled Maintenance', warning = false, }) {
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('z-[1000] sticky top-0 w-full flex items-center gap-x-3 px-6 py-2.5 sm:pr-3.5 lg:pl-8', warning ? 'bg-[#FFD795]' : 'bg-cta-primary-default') },
        warning && (react_1.default.createElement(solid_1.ExclamationCircleIcon, { className: "h-6 w-6 flex-shrink-0", style: { color: '#E29036', fill: '#E29036' } })),
        react_1.default.createElement("p", { className: (0, clsx_1.default)('text-sm leading-6 flex-1', warning ? 'text-[#151C23]' : 'text-white') },
            react_1.default.createElement("a", { href: "#" },
                react_1.default.createElement("strong", { className: "font-semibold" }, title),
                react_1.default.createElement("svg", { viewBox: "0 0 2 2", className: "mx-2 inline h-0.5 w-0.5 fill-current", "aria-hidden": "true" },
                    react_1.default.createElement("circle", { cx: 1, cy: 1, r: 1 })),
                message))));
}
exports.MaintenanceBanner = MaintenanceBanner;
//# sourceMappingURL=MaintenanceBanner.js.map